import apiClient from '@/services/axios'

class SMS_Service {
  constructor() {
    this.$api = apiClient
  }

  getTasks() {
    return this.$api.get('/admin/order-notification')
  }

  createTask(body) {
    return this.$api.post('/admin/order-notification', body)
  }

  updateTask(id, body) {
    return this.$api.put(`/admin/order-notification/${id}`, body)
  }

  deleteTask(id) {
    return this.$api.delete(`/admin/order-notification/${id}`)
  }
}

export default new SMS_Service()
